export const HEADER_SIZES = ['sm', 'md', 'lg'] as const;
export type HeaderSize = (typeof HEADER_SIZES)[number];

// Shared with the Header wrapper once it exists, so a fixed header's spacer
// can never disagree with the header's own rendered height.
export const HEADER_HEIGHT: Record<HeaderSize, string> = {
  sm: 'h-layout-sm',
  md: 'h-layout',
  lg: 'h-layout-lg',
};
